import * as React from "react";
import { ReactSpecimen, markdown } from "catalog";
import { SelectField, Tabs, Button, SecondaryButton, ThemenCombo, TimeCombo, LocationCombo, DimensionCombo, Crumb, LinkButton, InputField } from "./Controls";
export default () => markdown `

## Breadcrumbs
\`Crumb\`s are links with an icon and a short text. They route to another page.
${(<ReactSpecimen span={3}>
    <Crumb icon="ChevronLeft" label="Zurück" rightAligned={false} href="#/components/controls"/>
  </ReactSpecimen>)}
${(<ReactSpecimen span={3}>
    <Crumb icon="ArrowRight" label="Mehr" rightAligned href="#/components/controls"/>
  </ReactSpecimen>)}

## Combos

\`Combos\` are a combination of an icon and a short text, without link.
These predefined combos are built with default props on top of the generic \`<Combo />\` component. This generic component can also be used in this way:

~~~code|lang-javascript
<Combo icon={"iconName"} text={"some text"} rightAligned={boolean} />
~~~

${(<ReactSpecimen span={2}>
    <ThemenCombo />
    <DimensionCombo />
    <LocationCombo />
    <TimeCombo />
  </ReactSpecimen>)}

## Buttons
### Primary button
${(<ReactSpecimen>
    <Button text="Daten herunterladen" href={"#/components/controls"}/>
  </ReactSpecimen>)}

### Primary button with icon
${(<ReactSpecimen>
    <Button text="Daten herunterladen" icon="Download" href={"#/components/controls"}/>
  </ReactSpecimen>)}

### Secondary button
${(<ReactSpecimen>
    <SecondaryButton text="Daten herunterladen" href={"#/components/controls"}/>
  </ReactSpecimen>)}

### Secondary button with icon
${(<ReactSpecimen>
    <SecondaryButton text="Daten herunterladen" icon="Download" href={"#/components/controls"}/>
  </ReactSpecimen>)}

### Link Button
This button looks like the primary button but is actually an HTML link (\`<a href="" />\`). It is used for external link (they don't change the state of the app).
${(<ReactSpecimen>
    <LinkButton text="Bundesamt für Statistik" icon={"Externallink"} href={"#/components/controls"}/>
  </ReactSpecimen>)}

## Inputs
### Select
${(<ReactSpecimen>
    <SelectField icon="ChevronDown" options={["Relevanteste", "Meist gesuchte", "Im Trend", "Neuste"]} selected="Relevanteste" onChange={(e) => console.log(e)}/>
  </ReactSpecimen>)}

### Select with label
${(<ReactSpecimen>
    <SelectField label="Sortieren" icon="ChevronDown" options={["Relevanteste", "Meist gesuchte", "Im Trend", "Neuste"]} selected="Relevanteste" onChange={(e) => console.log(e)}/>
  </ReactSpecimen>)}

### Input
${(<ReactSpecimen>
    <InputField placeholder="Glossar durchsuchen"/>
  </ReactSpecimen>)}

### Input with icon
${(<ReactSpecimen>
    <InputField placeholder="Glossar durchsuchen" icon="Search"/>
  </ReactSpecimen>)}

### Input with label
${(<ReactSpecimen>
    <InputField label="Suche" placeholder="Glossar durchsuchen"/>
  </ReactSpecimen>)}

## Tabs
${(<ReactSpecimen>
    <Tabs tabs={["Grafik", "Tabelle"]} selected="Grafik" onTabChange={e => console.log(e.target.value)}/>
  </ReactSpecimen>)}

`;



// WEBPACK FOOTER //
// ./src/components/Controls.docs.tsx